module.exports = __webpack_public_path__ + "static/media/trae-gould.47b9d477.jpg";